/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_li_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorem Ipsum Generator — Placeholder Text | Toolverse`)
};

const es_li_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de Lorem Ipsum — Texto de marcador | Toolverse`)
};

const de_li_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorem Ipsum Generator — Platzhaltertext | Toolverse`)
};

const nl_li_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorem Ipsum Generator — Plaatsaanduidingstekst | Toolverse`)
};

const fr_li_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur Lorem Ipsum — Texte de remplissage | Toolverse`)
};

const it_li_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore di Lorem Ipsum — Testo Placeholder | Toolverse`)
};

const pt_br2_li_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Lorem Ipsum — Texto de Espaço Reservado | Toolverse`)
};

const pt_li_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador Lorem Ipsum — Texto Espaço Reservado | Toolverse`)
};

const ja_li_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorem Ipsum生成器 — プレースホルダーテキスト | Toolverse`)
};

const zh_li_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorem Ipsum 生成器 — 占位文本 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const li_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.li_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("li_meta_title", locale)
	if (locale === "en") return en_li_meta_title(inputs)
	if (locale === "es") return es_li_meta_title(inputs)
	if (locale === "de") return de_li_meta_title(inputs)
	if (locale === "nl") return nl_li_meta_title(inputs)
	if (locale === "fr") return fr_li_meta_title(inputs)
	if (locale === "it") return it_li_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_li_meta_title(inputs)
	if (locale === "pt") return pt_li_meta_title(inputs)
	if (locale === "ja") return ja_li_meta_title(inputs)
	return zh_li_meta_title(inputs)
};